import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import styles from './Badge.scss?inline';

@customElement('app-badge')
export class Badge extends LitElement {
    static styles = [unsafeCSS(styles)];
    @property({ type: String }) k_value?: string | number;
    @property({ type: Number }) k_maxNumericNumber = 999;
    @property({ type: Boolean, reflect: true }) k_isDot = false;

    private get formattedValue(): string {
        if (this.k_value == undefined || this.k_value == '') return '';
        const numericValue = Number(this.k_value);

        if (!isNaN(numericValue)) {
            if (numericValue > this.k_maxNumericNumber) {
                return `${this.k_maxNumericNumber}+`;
            }
            return numericValue.toString();
        }

        const textValue = String(this.k_value);
        if (textValue.length > 4) {
            return textValue.substring(0, 4);
        }

        return textValue;
    }

    render() {
        let displayValue = '';
        if (!this.k_isDot)
            displayValue = this.formattedValue;

        if (!this.k_isDot && !displayValue) return null;

        return html`
            <div class='badge ${this.k_isDot ? 'dot' : 'label'}'>
                ${!this.k_isDot ? displayValue : null}
            </div>
        `
    }
}